import React, { Component } from 'react';
import {setAndGetAttributes} from '../../../Components/FormInputFields/FormInputFunctions';
import Wrp from "../../../hoc/Wrp/Wrp";
import {isSet,numericValidationWithDotWithoutNegative} from '../../../Utils/CommonFunctions';

class Percentage extends Component {

  fieldOnChangeHandler(e){
    const {changeHandler,value,max,decimal} = this.props;
    let input_value = e.target.value;
    // var validNumber = new RegExp(/^\d*\.?\d*$/);
    // if (input_value <= 100) {
      const maxLength = max;
      const maxDecimalLength = decimal;
      let pattern;
      if(maxDecimalLength === 0){
          pattern = new RegExp(`^(\\d{0,${maxLength}})?$`);
      }else{
          pattern = new RegExp(`^(\\d{0,${maxLength}})(\\.\\d{0,${maxDecimalLength}})?$`);
      }
      if (pattern.test(input_value)) { 
        //changeHandler(input_value);
        //console.log('sssss')
        this.props.filterOnChange(input_value, this.props.attr1, 'percentage', this.props.filterObject.has_multiple_input,this.props.attr5,this.props.attr6);
      } else {
        //console.log('sssss1111')
        //changeHandler(isSet(value,''));
        this.props.filterOnChange(isSet(value,''), this.props.attr1, 'percentage', this.props.filterObject.has_multiple_input,this.props.attr5,this.props.attr6);
      }
    // }
  } 

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);  
    

    return (
      <Wrp>
        <input 
          type="text"
          {...attr}
          onKeyPress={numericValidationWithDotWithoutNegative}
          onChange={e=>this.fieldOnChangeHandler(e)}
          value={value}          
           /> 
      </Wrp>        
    );
  }
}

Percentage.defaultProps = {
  isMandatory:false,
  className: 'form-control',
  max:5,
  maxLength:5,
  decimal:2
}

export default Percentage;



// import React from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';
// import * as ShipConstants from '../../../Global/Constants';
// import { isSet,numericValidationWithDotWithoutNegative} from '../../../Utils/CommonFunctions';

// const Percentage = (props) => {

//   const fieldOnChangeHandler = (e) => {    
//     //const {changeHandler,value,max,decimal} = this.props;
//     let input_value = e.target.value;
//     console.log('fieldOnChangeHandler==',input_value)
//     const maxLength = 5;
//     const maxDecimalLength = 2;
//     let pattern;
//     if(maxDecimalLength === 0){
//         pattern = new RegExp(`^(\\d{0,${maxLength}})?$`);
//     }else{
//         pattern = new RegExp(`^(\\d{0,${maxLength}})(\\.\\d{0,${maxDecimalLength}})?$`);
//     }
//     if (pattern.test(input_value)) { 
//       props.filterOnChange(input_value, props.attr1, 'percentage', filterObject.has_multiple_input,props.attr5,props.attr6);
//     } else {
//       props.filterOnChange(isSet(value,''), props.attr1, 'percentage', filterObject.has_multiple_input,props.attr5,props.attr6);
//     }
//   }

//   let value = props.value;
//   let filterObject = props.filterObject;
//   let classname = props.classname ? "form-control "+props.classname : "form-control";
//   return (
//         <input type="text" 
//           value={props.value} 
//           className={classname} 
//           name="action1" 
//           onKeyPress={numericValidationWithDotWithoutNegative}
//           //onChange={e=>props.filterOnChange(e, props.attr1, 'percentage', filterObject.has_multiple_input,props.attr5,props.attr6)} 
//           onChange={e=>fieldOnChangeHandler(e)}
//         />
//   );
// }

// export default Percentage;